import api from "../configurations/axios";
import ReportingData from "../models/ReportingData";
import UserCapReportResponse from "../responses/UserCapReportResponse";

class ReportingService {
    async getReportingData(
        competitionId: number,
        startDate: string,
        endDate: string
    ): Promise<ReportingData | undefined> {
        try {
            const response = await api.get<ReportingData>(`/api/reporting/${competitionId}`, {
                params: {
                    startDate,
                    endDate,
                },
            });
            return response.data;
        } catch (error: any) {
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getUserCapReport(reportDate: string): Promise<UserCapReportResponse | undefined> {
        try {
            const response = await api.get<UserCapReportResponse>(`/api/reporting/user-cap-report`, {
                params: { reportDate },
            });
            return response.data;
        } catch (error: any) {
            console.error("error:", error.response?.data || error.message);
        }
    }
}

export default new ReportingService();
